module.exports = __webpack_public_path__ + "dist/img/yanzhenghua.7b5e189.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/content/yanzhenghua.png
// module id = lTSt
// module chunks = 1